import React from 'react';
import { List } from 'immutable';

// Types
import { QuestionTypeType } from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import { WpText } from 'Wpds/components/text';
import SharePageQuestionItem from '../SharePageQuestionReview/SharePageQuestionItem';
import AnonymousPeerReviewAlert from 'Dashboard/components/ThreeSixtyReviewPartials/AnonymousPeerReviewAlert/AnonymousPeerReviewAlert';

// Styles
import './SharePageQuestionReview.scss';

type Props = {
  review;
};

const SharePageQuestionReview = ({ review }: Props) => {
  const { slug: currentUserSlug } = useCurrentUser();
  const reviewSlug = ReviewsHelpers.getSlug(review);
  const self360 = ReviewsHelpers.getSelf360(review);
  const isPeerReviewSharedAnonymously = ReviewsUtils.isFeedbackSharedAnonymously({ review });
  const isCurrentUserCompiler = ReviewsUtils.isCurrentUserCompiler({ review, currentUserSlug });

  const selfReviewTemplate = ReviewsUtils.getFormTemplateForForm({ review, templateFormType: 'peer_review' });
  const questions = ReviewFormTemplatesHelpers.getQuestions(selfReviewTemplate) || List();

  const filteredQuestions = questions.filter(q => q.get('type') !== QuestionTypeType.TITLE_DESCRIPTION);

  const baseClassName = 'SharePageQuestionReview';

  return (
    <div className={baseClassName}>
      <WpText tag="h5" variant="bodyXl" bold>
        Individual responses
      </WpText>
      {!self360 && isCurrentUserCompiler && (
        <div className={`${baseClassName}__alert`}>
          <AnonymousPeerReviewAlert
            review={review}
            text={
              isPeerReviewSharedAnonymously
                ? '%receiverName% can see these individual responses, but names are not included.'
                : 'You’re the only one who can see these individual responses. %receiverName% cannot see them.'
            }
          />
        </div>
      )}
      {filteredQuestions.map(question => (
        <div
          className={`${baseClassName}__question`}
          key={`SharePageQuestionReview-${reviewSlug}-${ReviewFormTemplatesHelpers.getQuestionKey(question)}`}
        >
          <SharePageQuestionItem review={review} question={question} />
        </div>
      ))}
    </div>
  );
};

export default SharePageQuestionReview;
